export const EMPTY_VALUE = '-'

export const FORM = {
  PRICE_ID: 'price',
}
